<template>
  <div class="flvh265div-9">
    <div class="flvh265info">
      <div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(0,'left')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(0,'right')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(0,'up')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(0,'down')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container0">
          </video>
          <div v-if="playdescList[0] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[0] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(1,'left')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(1,'right')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(1,'up')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(1,'down')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container1">
          </video>
          <div v-if="playdescList[1] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[1] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(2,'left')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(2,'right')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(2,'up')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(2,'down')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container2">
          </video>
          <div v-if="playdescList[2] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[2] }}</div>
        </div>
      </div>
      <div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(3,'left')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(3,'right')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(3,'up')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(3,'down')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container3">
          </video>
          <div v-if="playdescList[3] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[3] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(4,'left')" v-if="cameraTypeList[4]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(4,'right')" v-if="cameraTypeList[4]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(4,'up')" v-if="cameraTypeList[4]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(4,'down')" v-if="cameraTypeList[4]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container4">
          </video>
          <div v-if="playdescList[4] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[4] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(5,'left')" v-if="cameraTypeList[5]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(5,'right')" v-if="cameraTypeList[5]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(5,'up')" v-if="cameraTypeList[5]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(5,'down')" v-if="cameraTypeList[5]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container5">
          </video>
          <div v-if="playdescList[5] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[5] }}</div>
        </div>
      </div>
      <div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(6,'left')" v-if="cameraTypeList[6]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(6,'right')" v-if="cameraTypeList[6]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(6,'up')" v-if="cameraTypeList[6]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(6,'down')" v-if="cameraTypeList[6]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container6">
          </video>
          <div v-if="playdescList[6] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[6] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(7,'left')" v-if="cameraTypeList[7]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(7,'right')" v-if="cameraTypeList[7]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(7,'up')" v-if="cameraTypeList[7]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(7,'down')" v-if="cameraTypeList[7]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container7">
          </video>
          <div v-if="playdescList[7] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[7] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(8,'left')" v-if="cameraTypeList[8]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(8,'right')" v-if="cameraTypeList[8]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(8,'up')" v-if="cameraTypeList[8]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(8,'down')" v-if="cameraTypeList[8]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container8">
          </video>
          <div v-if="playdescList[8] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[8] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "jessibuca-9",
  props: ['videolist', 'streamStatusList', 'isFullScreen', 'videonamelist', 'cameraTypeList', 'cameraDetailList'],
  data() {
    return {
      showOperateBtns: false,
      forceNoOffscreen: true,
      playList: [],
      playcount: 9,
      currentpage: 1,
      playdescList: [],
      reloadTimeOut: 5000,
      timeoutList: [-1, -1, -1, -1, -1, -1, -1, -1, -1],
      currentvideolist: [],
      palyCameraInfoList: ['', '', '', '', '', '', '', '', '']
    }
  },
  mounted() {
    // console.log('jessbuca9 mounted')
    // this.start();
    this.initPlayDescList();
    this.cameraTypeLists = this.cameraTypeList;
    this.cameraDetailsList = this.cameraDetailList;
    console.log('cameraDetailsList', this.cameraDetailList);
  },
  destroyed() {
    this.batchDestoryVideo();
    this.initPlayDescList();
  },
  methods: {
    cameraCtrl(index, direction) {
      console.log(this.cameraDetailList)
      this.$http.get(`/api/operateCamera?command=${direction}&indexCode=${this.cameraDetailList[index].cameraindexcode}`).then(res => {
        console.log(res)
      })
    },
    initPlayDescList() {
      this.playdescList = new Array(9).fill('online');
    },
    create(id) {
      this.playList.push('');
    },
    batchCreate() {
      for (let i = 0; i < this.playcount; i++) {
        this.create(i);
      }
    },
    playVideo(index, videourl) {
      let flvPlayer = '';
      if (index < this.playList.length) {
        flvPlayer = this.playList[index];
        if (flvPlayer != '') {
          // flvPlayer.destroy();
          // flvPlayer.destroy();
          // flvPlayer.load();
          // flvPlayer.play();
          try {
            flvPlayer.unload();
            flvPlayer.detachMediaElement();
            flvPlayer.destroy();
            flvPlayer = '';
          } catch (err) {
            console.log('destory video error', err, 'index: ', index);
          }
        }
      }

      let $container = document.getElementById('container' + index);
      flvPlayer = flvjs.createPlayer({
        type: 'flv',
        url: videourl,
        hasAudio: false // 是否有音频
      });

      flvPlayer.attachMediaElement($container);

      flvPlayer.on(flvjs.Events.ERROR, function (type) {
        console.log('flvjs.Events.ERROR: ', type, 'index: ', index)
        _this.reloadPlayer(index);
      })
      let _this = this;
      flvPlayer.on(flvjs.Events.LOADING_COMPLETE, function () {
        console.log('flvjs.Events.LOADING_COMPLETE: ', type, 'index: ', index)
        _this.reloadPlayer(index);
      })
      //muted
      flvPlayer.muted = true;
      flvPlayer.load();
      flvPlayer.play();
      this.playList[index] = flvPlayer;
    },
    reloadPlayer(index) {
      let _this = this;
      // console.log('index', index)
      // console.log(this.timeoutList)
      if (this.timeoutList[index] == -1) {
        let timeoutid = setTimeout(function () {
          if (index < _this.currentvideolist.length) {
            let videourl = _this.currentvideolist[index];
            try {
              console.log('start reload : ', index, 'url: ', videourl)
              _this.playVideo(index, videourl)
              console.log('reload : ', index, 'url: ', videourl, 'finish')

            } catch (err) {
              console.log('restart ', index, ' player error')
            } finally {
              _this.timeoutList.splice(index, 1, -1);
            }
          }
        }, this.reloadTimeOut);
        this.timeoutList.splice(index, 1, timeoutid)
      }
    },
    batchPlayVideo(item) {
      let videolist = item[0];
      let streamStatusList = item[1];
      let cameraDetailList = item[2];
      for (let index = 0; index < this.playcount; index++) {
        if (streamStatusList[index] == 'online') {
          this.playVideo(index, videolist[index]);
          this.playdescList.splice(index, 1, 'online');
        } else if (streamStatusList[index] == 'offline') {
          this.playdescList.splice(index, 1, 'offline');
        } else {
          this.playdescList.splice(index, 1, '');
        }
      }
      this.palyCameraInfoList = cameraDetailList;
    },
    destoryVideo(index) {
      let player = this.playList[index];
      try {
        if (player) {
          player.unload();
          player.detachMediaElement();
          player.destroy();
          player = '';
        }
      } catch (err) {
        console.log('destory video error', err);
      }
      // if(player){
      //   try{
      //     player.destory();
      //   }
      //   catch(err){
      //     console.log('destory video error', err)
      //   }
      // }
    },
    batchDestoryVideo() {

      if (this.playList.length > 0) {
        for (let index = 0; index < this.playcount; index++) {
          this.destoryVideo(index);
        }
        this.playList = [];
      }
      for (let index = 0; index < this.timeoutList.length; index++) {
        if (this.timeoutList[index] != -1) {
          clearTimeout(this.timeoutList[index]);
        }
      }
      this.timeoutList = [-1, -1, -1, -1, -1, -1, -1, -1, -1];
    },
    start() {
      this.batchDestoryVideo();
      this.batchCreate();
      this.batchPlayVideo(this.getPageVideoList(this.currentpage, this.playcount));
    },
    getPageVideoList(currentpage, playcount) {
      let start = (currentpage - 1) * playcount == 0 ? 0 : (currentpage - 1) * playcount;
      let videolist = this.videolist.slice(start, start + playcount);
      let streamStatusList = this.streamStatusList.slice(start, start + playcount);
      let cameraDetailList = this.videonamelist.slice(start, start + playcount);
      while (videolist.length < this.playcount) {
        videolist.push('');
        streamStatusList.push('');
        cameraDetailList.push('');
      }
      this.currentvideolist = videolist;
      return [videolist, streamStatusList, cameraDetailList]
    },
    switchplays(page) {
      this.currentpage = page;
      this.start();
    },
    switchStart() {
      this.currentpage = 1;
      this.start();
    },

    /*
    * 添加单个视频播放功能，供区域点位视频调用
    * date: 2023/02/15 17:41
    * created: lyy
    * */
    addSingleVideo(index, url, status) {
      if (status == 'online') {
        this.playVideo(index, url);
      }
      this.playdescList.splice(index, 1, status);
    },
    /**
     * 移除单个视频，供区域点位视频调用
     * date: 2023/02/15 17:41
     * created: lyy
     */
    removeSingleVideo(index) {
      if (this.playdescList[index] == 'online') {
        this.destoryVideo(index);
      }
      this.playdescList.splice(index, 1, '');
      this.playList.splice(index, 1, '');
    }

  }
}
</script>

<style scoped>
/*.jessibucadiv{*/
/*  position: relative;*/
/*  width: 100vw;*/
/*  margin: 0px;*/
/*  padding: 0px;*/
/*}*/
/*.flvh265div-9 .flvh265info{*/
/*  background-color: rgba(13, 14, 27, 0.9);*/
/*}*/
.flvh265div-9 .containeritem {
  /*background: rgba(13, 14, 27, 0.7);*/
  width: 32%;
  height: 20.3vh;
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  background: #000;
}

.flvh265div-9 .containeritem video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.flvh265div-9 .containeritem.videoFullScreen {
  background: rgba(13, 14, 27, 0.7);
  width: 33%;
  height: 33.3vh;
  display: inline-block;
  margin-right: 0px;
  margin-bottom: 0px;
  box-sizing: border-box;
  object-fit: fill;
  position: relative;
}

.flvh265div-9 .containeritem .playdesc {
  top: 50%;
  position: absolute;
  left: 40%;
  z-index: 900;
}

.flvh265div-9 .containeritem .cameradetail {
  /*height: 23vh;*/
  /*line-height: 23vh;*/
  vertical-align: center;
  bottom: 5px;
  position: absolute;
  left: 5px;
  /*background-color: rgba(78, 182, 183, 0.3);*/
  padding: 2px;
  z-index: 900;
  /*color:#fff;*/
  font-size: 12px;
}

.flvh265div-9 .containeritem.videoFullScreen .cameradetail {
  bottom: 10px;
  font-size: 16px;
}


</style>
